import { render, staticRenderFns } from "./ChangeManagerModal.vue?vue&type=template&id=442874f4&scoped=true"
import script from "./ChangeManagerModal.vue?vue&type=script&lang=ts"
export * from "./ChangeManagerModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442874f4",
  null
  
)

export default component.exports